const fields = [
  {
    dataIndex: 'userName',
    key: 'userName',
    title: '用户名',
  },
  {
    dataIndex: 'userName',
    key: 'userName',
    title: '企业信息',
  },
  {
    dataIndex: 'email',
    key: 'email',
    title: '邮箱',
  },
  {
    dataIndex: 'useStatusStr',
    key: 'useStatus',
    scopedSlots: {
      customRender: 'color',
    },
    title: '状态',
  },
  {
    dataIndex: 'createTime',
    key: 'createTime',
    title: '注册日期',
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: {
      customRender: 'action',
    },
  },
]
const formRow = [
  {
    span: 12,
    label: '用户名',
    component: 'AInput',
    placeholder: '请输入用户名',
    prop: 'userName',
    allowClear: true,
  },
  // {
  //   span: 12,
  //   label: '注册日期',
  //   component: 'ADate',
  //   prop: 'params',
  //   allowClear: true
  // }
]
const slotOpt = [
  {
    slot: 'action',
    component: 'Action',
    list: [{ name: '删除', cb: 'delete' }],
  },
]
module.exports = {
  fields,
  formRow,
  slotOpt,
}
